module.exports = __webpack_public_path__ + "static/img/matrix.748e4313.gif";